import React, {Fragment, useEffect, useRef, useState} from "react";
import {
    Alert,
    Button,
    Card,
    CardContent, Checkbox,
    Collapse, Dialog, DialogActions, DialogContent, DialogContentText,
    DialogTitle,
    Divider, FormControl, FormControlLabel, FormHelperText,
    Grid,
    IconButton, InputLabel, MenuItem, OutlinedInput, Select, Tooltip,
    Typography, useMediaQuery
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import CloseIcon from "@mui/icons-material/Close";
import StyledDataGrid from "../Custom/StyledDataGrid";
import CustomNoRowsOverlay from "../Custom/CustomNoRowsOverlay";
import PaidPeriodInfoService from "../../services/PaidPeriodInfoService";
import {useNavigate} from "react-router-dom";

const periodGridList = new PaidPeriodInfoService();

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {PaperProps: {style: {maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 250,},
    },
};

function getStyles(name, paymentTypes, theme) {
    return {fontWeight: paymentTypes.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,};
}

const PeriodSelection = ({employeeId}) => {

    const navigate = useNavigate();

    const [open, setOpen] = React.useState(false);
    const [openAlret, setOpenAlert] = useState(true);
    const [gridData, setGridData] = useState([]);
    const [data, setData] = useState({});
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [editRowsModel, setEditRowsModel] = React.useState({});
    const [editRowData, setEditRowData] = React.useState({});
    const [handleCheckBoxes, setHandleCheckBoxes] = useState(true);
    const [isCheckedYes, setIsCheckedYes] = useState('');
    const [isCheckedYesError, setIsCheckedYesError] = useState(false);
    const [isErrorOnPaymentType, setIsErrorOnPaymentType] = useState(false);
    const [isCheckedNo, setIsCheckedYesNo] = useState('');
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [paymentTypesSelected, setPaymentTypesSelected] = useState([]);
    const [selected, setSelected] = useState(true);

    function getFullName(params) {
        if(`${params.row.amount || ''}`){
            return params.row.amount;
        }
    }

    const columns = [
        {
            field: 'period', headerName: 'Period', width: 100, editable: false, flex: 1, type: 'string', sortable: false, filterable: false,
            renderCell: (params) => {return <div>{params.row['period'].period}</div>;
            },
            headerClassName: 'data-grid-header-colors lastcolumnSeparator .MuiDataGrid-columnSeparator--sideRight'
        },
        {
            field: 'amount', headerName: 'Amount', width: 100, editable: true, flex: 1,sortable: false, filterable: false,
            // renderCell: (params) => {
            //     return params.row['period'].period === "202003" && params.row.amount.value > 0 ? params.row.amount.value : params.row['period'].period === "202003" && <p>Double click to edit the cell</p>;
            // },
            headerClassName: 'data-grid-header-colors lastcolumnSeparator .MuiDataGrid-columnSeparator--sideRight'
        },
        {
            field: 'paidDate', headerName: 'Payment Date', width: 100, editable: true, flex: 1,sortable: false, type: 'date', filterable: false,
            // renderCell: (params) => {
            //     return params.row['period'].period === "202003" && params.row.paidDate > 0 ? params.row.paidDate : params.row['period'].period === "202003" && <p>Double click to edit the cell</p>;
            // },
            headerClassName: 'data-grid-header-colors lastcolumnSeparator .MuiDataGrid-columnSeparator--sideRight'
        },
    ];

    useEffect(() => {
        periodGridList.getPeriodGridList(setData, setGridData);
        periodGridList.getPaymentTypesList(setPaymentTypes);
    }, []);

    const handleEditRowsModelChange = React.useCallback(
        (model) => {
            const editedIds = Object.keys(model);
            if (editedIds.length === 0) {
                console.log(JSON.stringify(editRowData, null, 4));
            } else {
                setEditRowData(model[editedIds[0]]);
            }
            setEditRowsModel(model);
        },
        [editRowData],
    );

    // const handleRowEditCommit = React.useCallback(
    //     (params) => {
    //         console.log("2:");
    //         const id = params.id;
    //         const key = params.field;
    //         const value = params.value; },
    //     []
    // );

    const submitGrid = () => {
        let isSubmit = true;
        if(isCheckedYes === '' && isCheckedNo === ''){
            setIsCheckedYesError("Please select Yes or No");
            isSubmit = false;
        }
        if(isSubmit) {
            data['employeeid'] = employeeId;
            data['paidPeriodInfoList'] = gridData;
            data.paymentReceived = isCheckedYes;
            data.paymentType = paymentTypesSelected;
            periodGridList.updatePeriodGridList(data);
            navigate("/thankYouPop");
        }
    };

    const test1 = (newRow, oldRow) => {
        console.log("3");
    }

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        console.log("3:" + updatedRow);
        console.log("3.1:" + updatedRow['period']['period']);
        console.log("3.2:" + updatedRow['amount']);
        console.log("3.3:" + updatedRow['paidDate']);
        console.log("3.4:" + gridData);
        const itemIndex =  gridData.findIndex(obj =>{
            if(obj['period']['period'] == updatedRow['period']['period'])
            { console.log("4:find") ; return true}
            else {
                return false;
            }
        });
        console.log("itemIndex:" + itemIndex);

        if (itemIndex >= 0)
        {
            gridData[itemIndex]['amount']=updatedRow['amount'];
            gridData[itemIndex]['paidDate']=updatedRow['paidDate'];
        }
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const checkboxHandlerOnYes = () => {
        setIsCheckedYes(!isCheckedYes);
        setIsCheckedYesError(false);
    }

    const checkboxHandlerOnNo = () => {
        setIsCheckedYesNo(!isCheckedNo);
        setIsCheckedYesError(false);
        setPaymentTypesSelected({
            paymentTypeID: 4,
            paymentType: "None"
        });
    }

    const handleChangePaymentType = (event) => {
        const {target: { value },} = event;
        setPaymentTypesSelected(typeof value === 'string' ? value.split(',') : value,);
    };

    // const handleChangePaymentType = (e) => {
    //     e.preventDefault();
    //     if (e.target.value !== null && typeof(e.target.value) !== 'undefined'){
    //         setPaymentTypesSelected(e.target.value);
    //     }
    // }

    return (
        <Fragment>
            <Card variant="outlined" className={'periodPaidForm'} sx={{display: 'inline-block', mx: '20px', transform: 'scale(0.8)'}}>
                <CardContent>
                    <Typography fontSize={30} sx={{marginLeft: 14, marginTop: 1.75, paddingRight: 0.08, fontWeight: 100}}
                                className={'dark-font-color'}>TERS Pay-out Details</Typography>
                    <Divider className={'css-9mgopn-MuiDivider-root'} sx={{marginBottom: 10}}/>
                    <Collapse in={openAlret}>
                        <Alert severity={"success"} className={"form-alert"} action={
                            <IconButton aria-label="close" color="inherit" size="small" onClick={() => {setOpenAlert(false);}}>
                                <CloseIcon fontSize="inherit"/>
                            </IconButton>}>
                            <Typography fontSize={18} sx={{fontWeight: 100}} className={'dark-font-color'}>
                                Enter your TERS Amount received by double clicking on the Amount and Payment Date cells below.
                            </Typography>
                        </Alert>
                    </Collapse>
                    <Typography fontSize={16}
                                sx={{marginLeft: 14, marginTop: 2.75, paddingRight: 0.08, fontWeight: 100}}
                                className={'dark-font-color'}>Did you receive money for temporary employee/employer relief scheme pay-out?
                    </Typography>
                    {isCheckedYesError && <FormHelperText sx={{color: 'red', marginLeft: 14, fontSize: 15}}>{isCheckedYesError}</FormHelperText>}
                    <div className={'questionCheckBoxes'}>
                        {isCheckedNo ? false : <FormControlLabel control={<Checkbox checked={isCheckedYes} onChange={checkboxHandlerOnYes} inputProps={{ 'aria-label': 'controlled' }}/>} label="Yes"/>}
                        {isCheckedYes ? false : <FormControlLabel control={<Checkbox checked={isCheckedNo} onChange={checkboxHandlerOnNo} inputProps={{ 'aria-label': 'controlled' }}/>} label="No"/>}
                    </div>
                    {isCheckedYes ?
                    <div className={'paymentTypeDropdown'}>
                    <FormControl sx={{ m: 1, width: 300 }}>
                        <InputLabel id="demo-multiple-name-label">Payment Type</InputLabel>
                        <Select labelId="demo-multiple-name-label" id="demo-multiple-name"
                                value={paymentTypesSelected}
                                onChange={handleChangePaymentType}
                                input={<OutlinedInput label="Payment Type"/>}
                    MenuProps={MenuProps}>{paymentTypes.map((name1) => (
                    <MenuItem key={name1.key} value={name1}>{name1.paymentType}</MenuItem>))}
                    </Select>
                    </FormControl>
                    </div> : null}
                    <>
                        <div className={"data-grid-size"}>
                            <StyledDataGrid
                                getRowId={row => row.period.periodId}
                                components={{NoRowsOverlay: CustomNoRowsOverlay,}}
                                rows={gridData}
                                columns={columns}
                                editMode="row"
                                editRowsModel={editRowsModel}
                                rowsPerPageOptions={[]}
                                // onSelectionModelChange={gridData.amount}
                                onEditRowsModelChange={handleEditRowsModelChange}
                                experimentalFeatures={{ newEditingApi: true }}
                                processRowUpdate={processRowUpdate}
                            />
                        </div>
                    </>
                    <Grid container justifyContent={"flex-end"}>
                        <Grid item>{<Button sx={{marginRight: 20, marginTop: 2.5}} onClick={handleClickOpen} className="btn white-font lower-case">Next</Button>}</Grid>
                        <Dialog  fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
                            <div className={'dialogBorder'}>
                                <DialogTitle id="responsive-dialog-title">{"Ters payed month?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        Have you captured all the periods as per UIF or employer payments?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button className="btn2 white-font lower-case" autoFocus onClick={submitGrid} onClickCapture={handleClose}>
                                        Yes
                                    </Button>
                                    <Button className="btn2 white-font lower-case" onClick={handleClose} autoFocus>
                                        No
                                    </Button>
                                </DialogActions>
                            </div>
                        </Dialog>
                    </Grid>
                </CardContent>
            </Card>
        </Fragment>
    );

}

export default PeriodSelection;
